import { useMemo } from "react";
import { getMenuListItemControlRole } from "./getMenuListItemControlRole";
export const useMenuListItem = (mode, itemProps) => {
    const { id, checked, disabled, hasChildren: hasChildrenProp, items, inputType, isSelected, // TODO: deprecated, but currently still supported
    selected, onClick, onKeyDown, onIconClick, onNextClick, onSelect, label, linkProps } = itemProps;
    const hasChildren = useMemo(() => {
        if (hasChildrenProp) {
            return true;
        }
        if (items) {
            // TODO: async items?
            // if (typeof items === "function") {
            //   return true;
            // }
            if (items.length > 0) {
                return true;
            }
            return false;
        }
        return false;
    }, [hasChildrenProp, items]);
    const role = getMenuListItemControlRole({ mode });
    const roleStateProps = useMemo(() => {
        if (role === "menuitem" && inputType) {
            const menuItemInputRole = inputType === "radio" ? "menuitemradio" : "menuitemcheckbox";
            return { id, role: menuItemInputRole, "aria-disabled": disabled, "aria-checked": checked };
        }
        if (role === "menuitem") {
            return { id, role, "aria-disabled": disabled };
        }
        if (role === "option") {
            return { id, role, "aria-disabled": disabled, "aria-selected": selected ? selected : isSelected };
        }
        return {};
    }, [role, inputType, id, disabled, checked, selected, isSelected]);
    const handleClick = disabled
        ? () => { }
        : (event) => {
            hasChildren && event.stopPropagation(); // TODO: remove when useClickThrough is rolled out
            label && onClick && onClick(event, { ...itemProps }, onSelect); // TODO: prevent hover styles from rendering too, this is very misleading
        };
    const handleIconClick = disabled
        ? () => { }
        : (event) => {
            event.stopPropagation();
            if (onNextClick) {
                onNextClick(event, { ...itemProps }, onSelect);
            }
            else {
                onIconClick && onIconClick(event);
            }
        };
    const handleKeyDown = (event) => {
        if (onKeyDown) {
            onKeyDown(event);
            return;
        }
        // should also work with extra controls? probably not
        if (event.key === " " || event.key === "Enter") {
            // button and checkbox/radio will trigger onClick on their own
            if (event.currentTarget.tagName === "button" || (event.currentTarget.tagName === "input" && event.key === " ")) {
                return;
            }
            // Do not prevent when used with a link?
            if (!linkProps && event.currentTarget.tagName !== "A") {
                event.preventDefault();
            }
            !disabled && label && onClick && onClick(event, { ...itemProps }, onSelect);
        }
        else if (hasChildren &&
            event.key ===
                "ArrowRight" /** should still work in submenu scenario regardless of chosen pattern for help popover */) {
            if (onNextClick) {
                !disabled && onNextClick(event, { ...itemProps }, onSelect);
            }
            else if (onIconClick) {
                !disabled && onIconClick && onIconClick(event);
            }
            else {
                !disabled && label && onClick && onClick(event, { ...itemProps }, onSelect);
            }
        } /* else if (
          event.key === "Tab" &&
          // Only handle Tab key in Select mode
          mode === "select" &&
          onTabKeyPress
        ) {
          event.preventDefault();
          onTabKeyPress();
        } */ // TODO: re-enable confirm-on-focus-out
    };
    return {
        handleClick,
        handleIconClick,
        handleKeyDown,
        hasChildren,
        roleStateProps
    };
};
